import axios from 'axios'
// import { session, local } from "./session";
// import router from '@/router'
// import { Notify } from 'vant';
// import { Toast } from 'vant';

// 创建axios实例
const service = axios.create({
  baseURL: '/', // api 的 base_url
  timeout: 5000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 请求头的appId
    // config.headers['appId'] = 'anttalk'
    config.headers['appId'] = 'anttalk'
    config.headers['clientType'] = 'wapWX'
    // if ( session('user') ) {
    //   config.headers['Authorization'] = session('user').token // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data

    // if (res.code === 200 || res.success === 1 ) {
    //   return response.data
    // } else if (res.code === 300) {
    //
    //   console.log(response.data);
    //   return response.data
    // } else if (res.code === 401 || res.code === 403 || res.code === 302) {
    //
    //   return Promise.reject('error')
    // } else {
    //   console.log(response.data);
    //   return response.data
    // }
    if (res.code >= 500){
      // return Promise.reject('error')
      if(res.code===501){ // 支付密码不正确
        return res
      }
      // Notify({message: '服务器超时，请稍后重试！', duration: 3000});
      alert('服务器超时，请稍后重试！')
      return Promise.reject(response)
    }else {
      if(res.code===300 ){
        // Notify({message: res.message, duration: 3000});
        alert(res.message)
      }
      if(res.code===402){ // token过期
        // Notify({message: res.message, duration: 5000});
        alert(res.message)
      }
      if(res.code===401){ //登录过期
        console.log('登录过期！')
        alert(res.message)
        // Toast({message: '未登录或登录过期，重新登录中', duration: 1000})
        // session('user','')
        // session('token','')
        // session('userInfo','')
        // local('beforeLoginUrl', (window.location.pathname + window.location.search) )
        // let ua = navigator.userAgent.toLowerCase();
        // let pathName = ua.indexOf('micromessenger')>0 ? 'login' : 'loginPhone';
        // router.push( {name: pathName} )
      }
      return res
    }




  },
  error => {
    console.log('err' + error) // for debug
    // Notify({message: '服务器错误，请稍后重试！', duration: 3000});
    alert('服务器错误，请稍后重试！')
    return Promise.reject(error)
  }
)

export default service
